const constants = {
	API_URL: process.env.NODE_ENV === 'development' ? 'http://127.0.0.1:3300/api/' : 'https://api.grouphug.online/api/',

	// Subsidy model 2026: show new UI (per-pair session count, etc.) from this date.
	// Change to a past date to test, future date to disable.
	SUBSIDY_2026_START: new Date('2026-05-20T21:00:00.000Z'), // = 20.05.2026 00:00 Israel
	SUBSIDY_2026_PAIR_LIMIT: 7,
};

export default constants;
